module.exports = __webpack_public_path__ + "static/img/no-course.765a60f.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/no-course.png
// module id = vI47
// module chunks = 1